import { HttpClient } from 'api/http-client';

export type MetricsEvent = {
  originId: number;
  originType: MetricsEventOrigin;
  eventName: MetricsEventNames;
};

export enum MetricsEventOrigin {
  Task = 'Task',
  Attachment = 'Attachment',
}

export enum MetricsEventNames {
  TaskPaneViewed = 'TASK_PANE_VIEWED',
  EnteredAttachmentComparisonMode = 'ENTERED_ATTACHMENT_COMPARISON_MODE',
  AttachmentComparisionLinked = 'ATTACHMENT_COMPARISON_LINKED',
}
class MetricsEventHttpClient extends HttpClient {
  public async postMetricsEvent(data): Promise<MetricsEvent> {
    return this.post('/metrics/events', data);
  }
}

export const MetricsEventAPI = new MetricsEventHttpClient();
